export enum INVOICE_STATUS {
  draft = "DRAFT",
  open = "OPEN",
  paid = "PAID",
  voided = "VOIDED",
  failed_generation = "FAILED_GENERATION",
}

export enum LEGACY_INVOICE_STATUS {
  draft = "DRAFT",
  open = "OPEN",
  paid = "PAID",
  voided = "VOIDED",
  pending = "PENDING",
}

export const ORDER_TAB_TYPES = {
  APPLICANT_SUBMISSION: "applicant-submission",
  QUICKSCREEN: "quickscreen",
} as const;

export const PASS_THROUGH_ACCESS_FEES_URL =
  "https://certn.co/pricing/pass-through-access-fees/";
